import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './app/App';
import { initI18n } from './i18n';
import { useSettings } from './features/settings/settingsStore';

// After a new deploy, a page that is still open may ask for a screen chunk that no longer
// exists (blank screen). Reload once to get the new version; the flag stops a reload loop.
const RELOAD_FLAG = 'hoopscope.chunkReload';
window.addEventListener('vite:preloadError', (event) => {
  try {
    if (sessionStorage.getItem(RELOAD_FLAG)) return;
    sessionStorage.setItem(RELOAD_FLAG, '1');
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});
window.addEventListener('load', () => {
  setTimeout(() => {
    try {
      sessionStorage.removeItem(RELOAD_FLAG);
    } catch {
      /* storage blocked */
    }
  }, 10_000);
});

async function boot() {
  await initI18n(useSettings.getState().language);
  const root = document.getElementById('root');
  if (!root) return;
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
